var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_4108)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_573_4108)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.43346,
    y: 1.96618,
    width: 43.8319,
    height: 43.8319,
    rx: 2.14544,
    stroke: "#A3AED0",
    strokeWidth: 2.2993
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9327 21.2037C24.6286 22.706 22.6505 23.0794 21.8125 21.7926V21.7926C21.7678 21.7239 21.728 21.652 21.6936 21.5777L21.521 21.2052C21.2639 20.6504 20.9211 20.1392 20.5051 19.6904L20.3925 19.5689C20.0715 19.2225 19.7004 18.9258 19.2917 18.6887L18.3185 18.1243C17.4582 17.6254 16.9285 16.7073 16.9285 15.7152V15.7152C16.9285 14.9837 17.2173 14.2822 17.7323 13.7628L17.9808 13.5122C18.5553 12.9327 19.3086 12.5631 20.1199 12.4626L20.2978 12.4406C20.8484 12.3723 21.41 12.4212 21.9413 12.5824V12.5824C22.4231 12.7287 22.8748 12.9665 23.2675 13.2816V13.2816C23.7431 13.6632 24.1235 14.1498 24.3787 14.7029L24.5005 14.9667C24.7099 15.4204 24.8523 15.9019 24.9232 16.3962L25.0508 17.2859C25.0985 17.6186 25.1224 17.9543 25.1224 18.2904L25.1224 20.0257C25.1224 20.1856 25.1065 20.3451 25.0747 20.5019L24.9327 21.2037Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7996 23.4864C23.2812 23.0756 24.5144 24.6635 23.7435 25.9893V25.9893C23.7024 26.0599 23.6563 26.1275 23.6056 26.1916L23.3499 26.5144C22.9701 26.9939 22.6682 27.5297 22.4551 28.1022L22.3973 28.2575C22.2328 28.6996 22.1355 29.1637 22.1086 29.6344L22.0446 30.7544C21.988 31.7443 21.4073 32.6298 20.5199 33.0793V33.0793C19.8645 33.4112 19.1043 33.4726 18.4042 33.2502L18.0716 33.1446C17.2918 32.8969 16.6186 32.3948 16.1605 31.7194L16.0617 31.5737C15.7506 31.1151 15.5396 30.5947 15.4431 30.0495V30.0495C15.3554 29.5546 15.3636 29.0461 15.4677 28.5543V28.5543C15.5936 27.9594 15.8563 27.4016 16.2352 26.9248L16.4168 26.6962C16.7279 26.3047 17.0943 25.9601 17.5044 25.6731L18.2439 25.1558C18.5193 24.9631 18.8082 24.7901 19.1082 24.6382L20.6629 23.8507C20.8056 23.7785 20.9551 23.7205 21.1093 23.6778L21.7996 23.4864Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.683 24.1C23.5517 23.0646 24.2532 21.1776 25.7872 21.1299V21.1299C25.8684 21.1274 25.9496 21.1307 26.0304 21.1397L26.4429 21.1858C27.0514 21.2538 27.6669 21.2264 28.2671 21.1044L28.4305 21.0713C28.8945 20.977 29.342 20.8141 29.7582 20.588L30.7473 20.0507C31.6209 19.5761 32.6801 19.5995 33.5307 20.1123V20.1123C34.1614 20.4924 34.6166 21.1058 34.7976 21.8196L34.8808 22.1474C35.0817 22.9395 35.0088 23.7765 34.6739 24.5225L34.6043 24.6775C34.3768 25.1843 34.0449 25.6376 33.6304 26.0077V26.0077C33.2538 26.3439 32.8161 26.605 32.3415 26.7767V26.7767C31.7685 26.984 31.1551 27.0563 30.5498 26.9877L30.2567 26.9545C29.7587 26.898 29.2716 26.7701 28.8104 26.5746L27.5137 26.0251L25.5876 24.8641C25.4516 24.7821 25.3241 24.6868 25.207 24.5796L24.683 24.1Z",
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9998,
    cy: 23.455,
    rx: 3.77617,
    ry: 3.76124,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.8978,
    cy: 23.3534,
    rx: 2.65353,
    ry: 2.64303,
    fill: "#A3AED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.694 22.68C37.694 30.2457 31.5352 36.3867 23.9283 36.3867C16.3215 36.3867 10.1627 30.2457 10.1627 22.68C10.1627 15.1143 16.3215 8.97338 23.9283 8.97338C31.5352 8.97338 37.694 15.1143 37.694 22.68Z",
    stroke: "#A3AED0",
    strokeWidth: 2.2993
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_573_4108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7.39771,
    y: 19.2107,
    width: 9.19719,
    height: 9.19719,
    rx: 1.74739
  })), /*#__PURE__*/React.createElement("rect", {
    x: -7.39771,
    y: 19.2107,
    width: 9.19719,
    height: 9.19719,
    rx: 1.74739,
    stroke: "#A3AED0",
    strokeWidth: 4.5986,
    mask: "url(#path-8-inside-1_573_4108)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.711801,
    y1: 19.6885,
    x2: -0.711801,
    y2: 28.4254,
    stroke: "#A3AED0",
    strokeWidth: 2.2993
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.711801,
    y1: 19.6885,
    x2: -0.711801,
    y2: 28.4254,
    stroke: "#A3AED0",
    strokeWidth: 2.2993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.6781,
    y: 5.35986,
    width: 4.8927,
    height: 8.38749,
    rx: 1.74739,
    fill: "#A3AED0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_4108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.816528)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_573_4108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.5112,
    height: 45.9859,
    fill: "white",
    transform: "translate(-11.9963 0.816528)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/CVC.8b9add4a833b4acc648df1c50374697a.svg";
export { ForwardRef as ReactComponent };